import { CanDeactivateFn } from '@angular/router';

/**
 * A page that can refuse to be left, and answers for itself whether it should be.
 */
export interface ConfirmsLeaving {
  confirmLeave(): boolean | Promise<boolean>;
}

/**
 * Asks before leaving an opportunity that has no customer name.
 *
 * On the route rather than on the Close button, because Close is not the only way out —
 * the breadcrumb goes back to the list, the browser's back button does too, and the sidebar
 * leaves the module entirely. A check wired only to the button would be trivially walked
 * past, which is worse than no check: it looks like the work is protected when it is not.
 */
export const unsavedOpportunityGuard: CanDeactivateFn<ConfirmsLeaving> = (component) =>
  component?.confirmLeave?.() ?? true;
